import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/shop/exchange-orders";

export const exchangeOrders = {
    // ...example,
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}
